import { render } from "./NewsCard.vue?vue&type=template&id=fb3af6f6&scoped=true&ts=true"
import script from "./NewsCard.vue?vue&type=script&lang=ts"
export * from "./NewsCard.vue?vue&type=script&lang=ts"

import "./NewsCard.vue?vue&type=style&index=0&id=fb3af6f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb3af6f6"]])

export default __exports__